import { toast } from 'react-toastify';

// Default toast configuration
const defaultConfig = {
  position: 'bottom-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  newestOnTop: false,
  rtl: false,
  pauseOnFocusLoss: true
};

// Helper functions for showing different types of toasts
export const showToast = {
  success: (message) => {
    toast.success(message, defaultConfig);
  },
  error: (message) => {
    toast.error(message, defaultConfig);
  },
  info: (message) => {
    toast.info(message, defaultConfig);
  },
  warning: (message) => {
    toast.warning(message, defaultConfig);
  },
};

// Re-export react-toastify's toast for direct usage
export { toast }; 